import React from 'react';

const PaymentBillingAddressGuest = ({ addressMode, billingAddress }) => {
  if (addressMode === 'BRANCH_DELIVERY') return null;
  const addressFields = [
    'name',
    'line1',
    'line2',
    'line3',
    'line4',
    'line5',
    'postcode',
  ];

  return (
    <div className="checkout-address__column">
      <div className="checkout-address__address-container">
        <div className="checkout-address__address">
          <p>
            {addressFields.map(field =>
              billingAddress?.[field] ? (
                <React.Fragment key={field}>
                  {field === 'name' ? (
                    <strong>{billingAddress[field]}</strong>
                  ) : (
                    billingAddress[field]
                  )}
                  <br />
                </React.Fragment>
              ) : null,
            )}
          </p>
        </div>
      </div>
    </div>
  );
};
export default PaymentBillingAddressGuest;
